import { combineReducers } from "redux";
import {authReducer as auth} from './auth/authReducer';
import {messageReducer as message} from './message/MessageReducer';
import {commonReducer as common} from './common/CommonReducer'
import {inventoryReducer as inventory} from './inventory/InventoryReducer'
import {inboundsReducer as inbounds } from "./inbounds/inboundsReducer";
import {outboundsReducer as outbounds } from "./outbounds/outboundsReducer";
import {reportsReducer as reports} from "./reports/reportsReducer";
import {dashboardReducer as dashboard} from "./dashboard/dashboardReducer";
import {systemReducer as system} from './system/systemReducer'
import {billingReducer as billing} from './billing/billingReducer'
import {integrationReducer as integration} from "./integration/integrationReducer";
import {userWHMpReducer} from "./userWHMp/userWHMpReducer";

const reducer = combineReducers({
  auth,
  message,
  common,
  inventory,
  inbounds,
  outbounds,
  reports,
  dashboard,
  system,
  billing,
  integration,
  userWHMpReducer
})
export default reducer
